import { useCallback, useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";

import { Box, Stack, Modal, Typography, TextField, Button, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

import Toast from "../../utils/Toast";
import LoadingCircle from "../../utils/LoadingCircle";

import { userState } from "../../interface/MainInterface";
import { HttpMainApi } from "../../interface/main-api";

import S3Uploader from "../../utils/attach/S3UploaderViaApi";

interface propsType {
  userState: userState;
  short_key: string;
  callback: any;
}

const mainApi = new HttpMainApi();

const PopUploadThumbViaApi = (props: propsType, ref: any) => {
  const toastRef: any = useRef();
  const titleRef: any = useRef();
  const videoRef: any = useRef();

  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [attachFiles, setAttachFiles] = useState<any>([]);

  useEffect(() => {
    return () => {
      setOpenModal(false);
      setAttachFiles([]);
    };
  }, []);

  const open = useCallback(() => {
    setOpenModal(true);
  }, []);

  const close = () => {
    setAttachFiles([]);
    setOpenModal(false);
  };

  // 첨부파일 업로드 완료시 콜백
  const fncUploadComplete = async (result: any) => {
    if (result.status === "ok") {
      props.callback({ command: "upload_finish", path: result.fileInfo[0]?.FILE_PATH });
      close();
    } else {
      toastRef.current?.toast("업로드에 실패하였습니다. 잠시 후 다시 이용해주세요.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80%", md: "50%", lg: "40%" },
            maxWidth: "90%",
            maxHeight: "90%",
            bgcolor: "background.paper",
            border: "0px solid #000",
            borderRadius: "1rem",
            boxShadow: 24,
            p: 3,
            zIndex: 990,
          }}
        >
          <Stack direction="column" spacing={2}>
            <Stack direction="row" spacing={2} sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography gutterBottom sx={{ lineHeight: "40px", fontWeight: "800 !important" }}>
                {"쇼츠 썸네일 이미지 업로드"}
              </Typography>
              <Tooltip title="창닫기">
                <IconButton aria-label="close" onClick={close}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Stack>
            {attachFiles.length === 0 && (
              <S3Uploader
                userState={props.userState}
                uploadDir={`short_thumb/${props.short_key}`}
                multiple={false}
                callBack={fncUploadComplete}
                setIsLoading={setIsLoading}
                borderRadius=""
                width="100%"
                variant="contained"
                buttonText="이미지 선택"
                dragDrop={true}
                acceptableFormats={["image/*"]}
              />
            )}
          </Stack>
        </Box>
      </Modal>
      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default forwardRef(PopUploadThumbViaApi);
